import React, { useState, useEffect } from "react";

// 1. Importe o componente 'Gesture' juntamente com os outros
import { MediaPlayer, MediaProvider, Poster, Gesture } from "@vidstack/react";
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/base.css";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";

import { CloudinaryVideo, CloudinaryImage } from "@cloudinary/url-gen";

export default function VideoPlayer({ publicId }) {
  const [videoSrc, setVideoSrc] = useState(null);
  const [posterUrl, setPosterUrl] = useState("");
  const [isPosterVisible, setPosterVisible] = useState(true);
  const cloudName = "dqtcm6eo9";

  useEffect(() => {
    const videoUrl = new CloudinaryVideo(publicId, { cloudName: cloudName })
      .format("auto")
      .quality("auto")
      .toURL();
    const posterUrl = new CloudinaryImage(publicId, { cloudName: cloudName })
      .setAssetType("video")
      .format("auto")
      .quality("auto")
      .toURL();

    setVideoSrc({ src: videoUrl, type: "video/mp4" });
    setPosterUrl(posterUrl);
  }, [publicId]);

  function handlePlay() {
    setPosterVisible(false);
  }

  if (!videoSrc) {
    return (
      <div style={{ backgroundColor: "#000" }}></div>
    );
  }

  return (
    <div>
      <MediaPlayer
        title="Kit Neuroalfabetização"
        src={videoSrc}
        playsInline={true}
        onPlay={handlePlay}
        className="player"
      >
        <MediaProvider />

        {isPosterVisible && (
          <Poster
            src={posterUrl}
            alt="Material do Kit Neuroalfabetização"
            style={{
              display: "block",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        )}

        {/* 2. Adicione o componente Gesture aqui */}
        {/* Ele vai cobrir a área do vídeo e capturar os cliques */}
        <Gesture event="pointerup" action="toggle:paused" />
        <Gesture event="dblpointerup" action="toggle:fullscreen" />

        <DefaultVideoLayout icons={defaultLayoutIcons} />
      </MediaPlayer>
    </div>
  );
}
